<template>
  <div class="contents">
      <!-- <Navbar></Navbar> -->
      <div class="layer">
        <div class="title">多角色分层</div>
        <div class="write">
            无论是管理员、代理、商家；<br/>
            系统按角色分层，精心设计，满足不同角色的一切需求
        </div>
        <div class="port">
            <img src="./images/computer.png" alt="电脑" oncontextmenu="return false;" onselectstart="return false;">
        </div>
    </div>
  </div>
</template>
<script>
import Navbar from '../Navbar'
export default {
  name:'layer',
  components:{Navbar}
}
</script>

<style scoped>
/* .contents .header{
    position: relative;
    z-index: 0;
} */
.contents{
    width:100%;
    /*height: 1076px;*/
    background-color: #fafafa;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.layer{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
    .title{
        font-family: 微软雅黑;
	font-size: 50px;
	line-height: 0px;
	letter-spacing: 5px;
    height: 50px;
    line-height: 50px;
    margin-top:149px;
    color: #333333;
    }
    .write{
	height: 66px;
	font-family: 微软雅黑;
	font-size: 24px;
	letter-spacing: 1px;
	color: #999999;
    margin-top:51px;
    text-align: center;
    line-height: 33px;
    }
    .port{
    width: 996px;
	height: 645px;
    margin-top:74px;
    }
/* @media screen and (max-height:800px){
    .layer{
        transform: scale(0.8);
    }
    .title{
        margin-top:155px;
    }
    .write{
        margin-top:28px;
    }
    .port{
        margin-top:38px;
    }
} */
@media screen and (max-width:1100px){
    .port{
        transform: scale(0.8);
    }
}
</style>




// WEBPACK FOOTER //
// src/components/software/layer.vue